// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import initialContactLookupFormValues from 'components/SearchAndSelect/Sets/Contact/initialFormValues'
import { initialize, setSubmitSucceeded } from 'redux-form'

const getSiteContactLookupInitialValues = (sourceForm, lookupFormName) => (dispatch, getState) => {
  const initialValues = { ...initialContactLookupFormValues }

  let triggerSearchOnMount = false

  try {
    const { contactId } = getState().form[sourceForm].values

    if (contactId.length > 0) {
      initialValues.serviceContactCode = contactId[0].contactCode
      triggerSearchOnMount = true
    }
  } catch (e) {
    console.warn(`Warning: tried to initialize Contact Lookup for sourceForm ${sourceForm} however the sourceForm was not properly initialized.`)
    console.warn(e)
  }

  // if we want the lookup to auto search on mount, we need set some things up in redux
  if (triggerSearchOnMount) {
    dispatch(initialize(lookupFormName, initialValues))
    dispatch(setSubmitSucceeded(lookupFormName))
  }

  return {
    initialValues,
    triggerSearchOnMount,
  }
}

export default getSiteContactLookupInitialValues
